
<script>
import moment from 'moment'
import { nToWord } from '@/utils/helpers'
import { services } from '@/utils/constants'
import searchIcon from '@/assets/images/icons/search-alt.svg?inline'

moment.locale('ru')

export default {
  name: 'search-label',
  components: {
    searchIcon
  },
  props: {
    requiredFields: {
      type: Array,
      default: () => []
    },
    service: {
      type: String,
      default: () => null
    }
  },
  data: () => ({
    renderFields: []
  }),
  watch: {
    '$route.query': {
      handler() {
        this.setFieldsValue()
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    showForm() {
      this.$emit('click')
    },
    setFieldsValue() {
      this.renderFields = []
      const params = this.$route.query
      const paramsKeys = Object.keys(params)

      this.requiredFields.forEach((item) => {
        if (paramsKeys.includes(item)) {
          this.renderFields.push(this[`${item}Format`](params[item]))
        }
      })
    },
    serviceFormat: service => services.find(item => item.service === service).name,
    placeNameFormat: data => decodeURI(data),
    checkInDateFormat: data => `с ${moment(data, 'DD.MM.YYYY').format('DD MMMM, dddd')}`,
    durationFormat: data => `${data} ${nToWord(data, ['ночь', 'ночи', 'ночей'])}`,
    roomsFormat(data) {
      let adultCounter = 0
      let childCounter = 0

      const touristsKeys = Object.keys(data)

      touristsKeys.forEach((item) => {
        const tourist = data[item]

        adultCounter += tourist.adults
        childCounter += tourist.children
      })

      const adultCounterFormat = `${adultCounter} ${nToWord(adultCounter, ['взрослый', 'взрослых', 'взрослых'])}`
      const childCounterFormat = childCounter > 0
        ? ` ${childCounter} ${nToWord(childCounter, ['ребенок', 'ребенка', 'детей'])}`
        : ''

      return adultCounterFormat + childCounterFormat
    }
  }
}
</script>

<template>
  <div
    v-if="renderFields.length"
    class="search-label"
    @click="showForm"
  >
    <search-icon
      class="search-label__icon"
    />
    <div
      v-if="service"
      class="search-label__item"
    >
      <p>{{ service }}</p>
    </div>
    <div
      v-for="(item, index) in renderFields"
      :key="index"
      class="search-label__item"
    >
      <p>{{ item }}</p>
    </div>
  </div>
</template>
